<script setup lang="ts">
defineProps<{
  gregorian: string;
  hijri: string;
}>();
</script>

<template>
  <div v-if="gregorian || hijri" class="px-4 sm:px-6 pb-3 mb-2 border-b border-gray-100 dark:border-gray-800">
    <div class="text-center space-y-0.5">
      <p v-if="gregorian" class="text-sm text-gray-600 dark:text-gray-300 leading-snug">
        <span aria-hidden="true">📅 </span>{{ gregorian }}
      </p>
      <p v-if="hijri" class="text-xs text-gray-500 dark:text-gray-400 leading-snug">
        <span aria-hidden="true">🌙 </span>{{ hijri }}
      </p>
    </div>
  </div>
</template>
